import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../lib/firebase";

export const saveCustomRequest = async (requestData) => {
  try {
    const docRef = await addDoc(collection(db, "customRequests"), {
      ...requestData,
      status: "pending",
      createdAt: serverTimestamp(),
    });
    return docRef.id;
  } catch (error) {
    console.error("Error saving custom request:", error);
    throw error;
  }
};
